<template>
  <main>
    <svg
      data-name="Layer 1"
      width="280"
      viewBox="0 0 869.99994 520.13854"
      version="1.1"
      id="svg147"
      sodipodi:docname="undraw_login_re_4vu2.svg"
      inkscape:version="1.1.1 (eb90963e84, 2021-10-02)"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:svg="http://www.w3.org/2000/svg"
    >
      <defs id="defs151" />
      <sodipodi:namedview
        id="namedview149"
        pagecolor="#ffffff"
        bordercolor="#666666"
        borderopacity="1.0"
        inkscape:pageshadow="2"
        inkscape:pageopacity="0.0"
        inkscape:pagecheckerboard="0"
        showgrid="false"
        inkscape:zoom="0.49051728"
        inkscape:cx="274.20033"
        inkscape:cy="-35.676623"
        inkscape:window-width="1920"
        inkscape:window-height="962"
        inkscape:window-x="0"
        inkscape:window-y="27"
        inkscape:window-maximized="1"
        inkscape:current-layer="svg147"
      />
      <path
        d="m 666.09239,514.25664 c -11.13833,-9.4118 -17.90393,-24.27967 -16.12965,-38.75366 1.77428,-14.47399 12.76358,-27.78 27.01831,-30.85364 14.25473,-3.07364 30.50415,5.43465 34.83378,19.3594 2.3828,-26.84637 5.12854,-54.81757 19.40179,-77.67976 12.92407,-20.70115 35.3088,-35.51364 59.5688,-38.16357 24.26,-2.64993 49.80265,7.35859 64.93275,26.50671 15.13,19.14812 18.8346,46.98549 8.2379,68.96911 -7.8063,16.19456 -22.188,28.24676 -37.25663,38.05184 a 240.45181,240.45181 0 0 1 -164.45376,35.97709 z"
        fill="#f2f2f2"
        id="path97"
      />
      <path
        d="m 831.72785,356.0788 a 393.41394,393.41394 0 0 0 -54.82622,54.44229 394.561,394.561 0 0 0 -61.752,103.194 c -1.112,2.72484 3.31272,3.911 4.4123,1.21642 A 392.34209,392.34209 0 0 1 834.9634,359.31434 c 2.28437,-1.86015 -0.97,-5.08035 -3.23555,-3.23554 z"
        fill="#ffffff"
        id="path99"
      />
      <path
        d="m 280.06709,511.69941 c 15.2985,-12.92712 24.591,-33.34815 22.15408,-53.22817 -2.43692,-19.88002 -17.53079,-38.15588 -37.10966,-42.37749 -19.57887,-4.22161 -41.89745,7.46449 -47.8442,26.59014 -3.27278,-36.87349 -7.04406,-75.29195 -26.64837,-106.69317 -17.75122,-28.433 -48.49666,-48.778 -81.81777,-52.41768 -33.32111,-3.63968 -68.40395,10.107 -89.18511,36.407 -20.78116,26.3 -25.86934,64.53459 -11.31476,94.72909 10.72185,22.24324 30.47528,38.79693 51.17195,52.26422 66.02954,42.9653 147.93912,60.88443 225.8773,49.41454"
        fill="#f2f2f2"
        id="path101"
      />
      <path
        d="m 52.56673,294.44208 a 540.35491,540.35491 0 0 1 75.30383,74.77651 548.0761,548.0761 0 0 1 59.38606,87.89068 545.835,545.835 0 0 1 25.43041,53.8463 c 1.52726,3.74257 -4.55,5.37169 -6.06031,1.67075 a 536.35952,536.35952 0 0 0 -49.009,-92.727 539.73411,539.73411 0 0 0 -65.72875,-81.19837 538.44066,538.44066 0 0 0 -43.76626,-39.81484 c -3.13759,-2.55492 1.33232,-6.97788 4.444,-4.444 z"
        fill="#ffffff"
        id="path103"
      />
      <path
        d="M 839.98157,519.64344 H 101.6876 a 1.19069,1.19069 0 0 1 0,-2.38137 h 738.29397 a 1.19069,1.19069 0 0 1 0,2.38137 z"
        fill="#3f3d56"
        id="path135"
      />
      <g id="g1290">
        <path
          d="m 624.49997,519 h -365 V 144.5 C 259.49997,64.82227 324.32224,0 403.99973,0 h 76.00049 c 79.67749,0 144.49975,64.82227 144.49975,144.5 z"
          fill="#f2f2f2"
          id="path105"
        />
        <path
          d="m 548.49997,519 h -289 V 144.5 a 143.38177,143.38177 0 0 1 27.59571,-84.94434 c 0.66381,-0.90478 1.32592,-1.79785 2.00878,-2.68115 a 144.46633,144.46633 0 0 1 30.75415,-29.85058 c 0.65967,-0.48 1.322,-0.95166 1.99415,-1.42334 a 144.15958,144.15958 0 0 1 31.47216,-16.459 c 0.66089,-0.25049 1.33374,-0.50146 2.00659,-0.74219 a 144.01979,144.01979 0 0 1 31.1084,-7.33593 c 0.65772,-0.0899 1.333,-0.16016 2.0083,-0.23047 a 146.28769,146.28769 0 0 1 31.10547,0 c 0.67334,0.0703 1.34864,0.14062 2.01416,0.23144 a 143.995,143.995 0 0 1 31.10034,7.335 c 0.6731,0.24073 1.346,0.4917 2.00879,0.74268 a 143.79947,143.79947 0 0 1 31.10645,16.21582 c 0.67163,0.46143 1.344,0.93311 2.00635,1.40478 a 145.987,145.987 0 0 1 18.38354,15.564 144.305,144.305 0 0 1 12.72437,14.55078 c 0.68066,0.88037 1.34277,1.77344 2.00537,2.67676 A 143.38227,143.38227 0 0 1 548.49997,144.5 Z"
          fill="#cccccc"
          id="path107"
        />
        <circle
          cx="524.99994"
          cy="335.5"
          r="16"
          fill="#2fffe7"
          id="circle109"
        />
        <polygon
          points="576.506,460.495 594.601,460.496 594.599,507.783 582.339,507.783 "
          fill="#ffb8b8"
          id="polygon111"
        />
        <path
          d="m 573.58165,504.27982 h 23.64384 v 14.88687 h -38.53071 v 0 a 14.88688,14.88688 0 0 1 14.88688,-14.88688 z"
          fill="#2f2e41"
          id="path113"
        />
        <polygon
          points="637.506,460.495 655.601,460.496 655.599,507.783 643.339,507.783 "
          fill="#ffb8b8"
          id="polygon115"
        />
        <path
          d="m 634.58165,504.27982 h 23.64384 v 14.88687 h -38.53071 v 0 a 14.88688,14.88688 0 0 1 14.88688,-14.88688 z"
          fill="#2f2e41"
          id="path117"
        />
        <path
          d="m 533.09755,338.66962 a 10.74272,10.74272 0 0 1 4.51052,-15.84307 l 41.67577,-114.86667 20.50713,11.19139 -47.58476,109.77071 a 10.80091,10.80091 0 0 1 -19.10866,9.74764 z"
          fill="#ffb8b8"
          id="path119"
        />
        <path
          d="m 649.33641,360.25357 a 10.74269,10.74269 0 0 1 -2.89305,-16.21659 l -12.91076,-121.50941 23.33776,1.06622 5.36567,119.52048 a 10.80091,10.80091 0 0 1 -12.89962,17.13934 z"
          fill="#ffb8b8"
          id="path121"
        />
        <circle
          cx="612.10577"
          cy="162.12254"
          r="24.561029"
          fill="#ffb8b8"
          id="circle123"
        />
        <path
          d="m 649.17955,332.61864 h -74.04687 l 0.0891,-0.57617 c 0.13306,-0.86133 13.19678,-86.439 3.56177,-114.436 a 11.813,11.813 0 0 1 6.06933,-14.5835 h 2.5e-4 c 13.77173,-6.48535 40.20752,-14.47119 62.52,4.90918 a 28.23448,28.23448 0 0 1 9.45947,23.396 z"
          fill="#2fffe7"
          id="path125"
        />
        <path
          d="m 589.35436,258.25047 -33.33667,-6.7632 15.62622,-37.02978 a 13.99723,13.99723 0 0 1 27.10571,6.99755 z"
          fill="#2fffe7"
          id="path127"
        />
        <path
          d="m 632.0504,270.80809 -2.00415,-45.94141 c -1.51977,-8.63623 3.42408,-16.80029 11.02735,-18.13476 7.60547,-1.32959 15.03174,4.66016 16.55835,13.35986 l 7.533,42.92774 z"
          fill="#2fffe7"
          id="path129"
        />
        <path
          d="m 646.71603,327.1186 c 11.91455,45.37671 13.21436,103.0694 10,166 l -16,-2 -29,-120 -16,122 -18,-1 c -5.37744,-66.02972 -10.61328,-122.71527 -2,-160 z"
          fill="#2f2e41"
          id="path131"
        />
        <path
          d="m 628.28907,181.10401 c -4.582,4.88079 -13.09131,2.26067 -13.68835,-4.40717 a 8.05467,8.05467 0 0 1 0.0101,-1.55569 c 0.30826,-2.95357 2.01461,-5.63506 1.60587,-8.7536 a 4.59046,4.59046 0 0 0 -0.84011,-2.14892 c -3.65124,-4.88933 -12.22227,2.18687 -15.6682,-2.23929 -2.113,-2.714 0.3708,-6.98713 -1.25065,-10.02051 -2.14006,-4.00358 -8.47881,-2.0286 -12.45388,-4.22116 -4.42275,-2.43948 -4.15822,-9.22524 -1.24686,-13.35269 3.55052,-5.03359 9.77572,-7.71951 15.92336,-8.10661 6.14764,-0.3871 12.25292,1.27475 17.99229,3.51145 6.52109,2.54134 12.98768,6.05351 17.00067,11.78753 4.88021,6.97317 5.34986,16.34793 2.90917,24.50174 -1.4847,4.96005 -6.55178,11.01924 -10.29345,15.00492 z"
          fill="#2f2e41"
          id="path133"
        />
        <path
          d="m 468.99997,410.5 h -130 a 6.46539,6.46539 0 0 1 -6.5,-6.41531 V 113.91527 a 6.46539,6.46539 0 0 1 6.5,-6.41531 h 130 a 6.46539,6.46539 0 0 1 6.5,6.41531 v 290.16942 a 6.46539,6.46539 0 0 1 -6.5,6.41531 z"
          fill="#ffffff"
          id="path137"
        />
        <rect
          x="332.49994"
          y="201.38965"
          width="143"
          height="2"
          fill="#cccccc"
          id="rect139"
        />
        <rect
          x="332.99994"
          y="315.5"
          width="143"
          height="2"
          fill="#cccccc"
          id="rect141"
        />
        <rect
          x="377.49994"
          y="107.5"
          width="2"
          height="304"
          fill="#cccccc"
          id="rect143"
        />
        <rect
          x="427.49994"
          y="107.5"
          width="2"
          height="304"
          fill="#cccccc"
          id="rect145"
        />
        <g
          id="Logo"
          transform="matrix(0.76840215,0,0,0.76840215,312.10355,42.384709)"
        >
          <path
            d="M 238.33,7 238,6.25 h -1.59 l -0.33,0.76 h -0.61 L 237,3.75 h 0.49 L 238.93,7 Z m -1.72,-1.22 h 1.2 l -0.6,-1.39 z"
            id="path1224"
          />
          <path d="M 239.28,7 V 3.75 h 0.59 V 7 Z" id="path1226" />
          <path
            d="m 238.1,11.22 a 5.61,5.61 0 1 1 5.61,-5.61 5.62,5.62 0 0 1 -5.61,5.61 z m 0,-10.61 a 5,5 0 1 0 5,5 5,5 0 0 0 -5,-5 z"
            id="path1228"
          />
          <path
            d="M 224,5.56 V 60.9 h -11.12 v -4.62 c -2.91,3.51 -7.16,5.22 -12.53,5.22 -11.34,0 -20.07,-8 -20.07,-20.66 0,-12.66 8.72,-20.66 20.07,-20.66 4.92,0 9.1,1.57 12,4.85 V 5.56 Z m -11.42,35.28 c 0,-6.94 -4.48,-11.11 -10.22,-11.11 -5.74,0 -10.29,4.17 -10.29,11.11 0,6.94 4.47,11.16 10.29,11.16 5.82,0 10.22,-4.22 10.22,-11.16 z"
            id="path1230"
          />
          <path
            d="m 51.39,20 a 20,20 0 0 0 -6.88,1.17 16.17,16.17 0 0 1 4.15,8.9 c 4.64,0 7.5,3 7.5,9.47 V 60.7 H 67.8 v -23 C 67.8,25.5 60.94,20 51.39,20 Z M 23.72,20 A 15.51,15.51 0 0 0 11.11,25.2 V 20.58 H 0 V 60.7 H 11.64 V 40.57 a 12.92,12.92 0 0 1 1.51,-6.57 7.91,7.91 0 0 1 7.29,-3.92 9.81,9.81 0 0 1 1.57,0.12 c 3.87,0.6 6,3.6 6,9.35 V 60.7 H 40 V 36.22 C 40,32.52 38.43,20.65 23.72,20 Z"
            id="path1232"
          />
          <path
            d="m 171.78,37.73 v 23 H 160.14 V 39.52 c 0,-6.49 -3,-9.48 -8.13,-9.48 -5.59,0 -9.62,3.44 -9.62,10.82 V 60.7 H 130.76 V 20.57 h 11.11 v 4.7 C 145,21.84 149.7,20 155.15,20 c 9.47,0 16.63,5.49 16.63,17.73 z"
            id="path1234"
          />
          <path
            d="m 111.06,20.65 -6,14.37 5.44,13.23 11.74,-27.6 z m -34.61,0 17.38,40.42 -0.15,0.38 c -1.57,3.58 -3.36,5 -6.56,5 a 10.34,10.34 0 0 1 -6.57,-2.53 l -4.25,8.27 c 2.61,2.31 7.09,3.65 11.19,3.65 7.23,0 12.75,-2.91 16.63,-12.6 l 0.93,-2.2 -16.6,-40.39 z"
            id="path1236"
          />
        </g>
      </g>
    </svg>
    <p class="mb-3 mt-4">
      You have been logged out due to inactivity. <br />
      Click the button below to login agian.
    </p>
    <b-btn variant="primary" size="lg" @click="logout"> Login </b-btn>
  </main>
</template>

<script>
import Vue from "vue";

export default {
  name: "LoggedOut",
  mounted() {
    // Remove auth tokens from localstorage when redirected to idle page
    Vue.prototype.$authService.removeTokensFromLocalStorage();
  },
  methods: {
    logout() {
      // Trigger logout on click, which will redirect to login screen
      Vue.prototype.$authService.logout();
    },
  },
};
</script>

<style lang="scss">
#app.page-LoggedOut {
  nav {
    display: none !important;
  }
  main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  p {
    line-height: 2em;
    text-align: center;
  }
  button {
    min-width: 140px;
  }
}
</style>
